globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { memo } from 'react';
import { useTranslation } from 'next-i18next';
import { openInNewTab } from '@restworld/utils-common';
import { Button, Title } from '../../design-system';
/* eslint-disable-next-line */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var JobNotFoundPage = /*#__PURE__*/memo(function (_ref) {
  var twStyle = _ref.twStyle,
      title = _ref.title,
      subTitle = _ref.subTitle,
      icon = _ref.icon,
      _ref$primaryButtonPro = _ref.primaryButtonProps;
  _ref$primaryButtonPro = _ref$primaryButtonPro === void 0 ? {} : _ref$primaryButtonPro;
  var primaryBtnTitle = _ref$primaryButtonPro.title,
      _ref$primaryButtonPro2 = _ref$primaryButtonPro.onClick,
      primaryBtnOnClick = _ref$primaryButtonPro2 === void 0 ? function () {
    return openInNewTab("/worker");
  } : _ref$primaryButtonPro2,
      secondaryButtonProps = _ref.secondaryButtonProps;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Wrapper, {
    twStyle: twStyle,
    children: [icon, /*#__PURE__*/_jsx(Title, {
      content: title !== null && title !== void 0 ? title : t('common:location_not_found_we_looked_everywhere'),
      textColor: "black",
      fontSize: "extraLarge",
      fontWeight: "semibold"
    }), /*#__PURE__*/_jsx(Title, {
      content: subTitle !== null && subTitle !== void 0 ? subTitle : t('common:the_location_may_be_non_existent_or_no_longer_active'),
      textColor: "gray",
      fontSize: "base",
      fontWeight: "normal"
    }), /*#__PURE__*/_jsx(Button, {
      title: primaryBtnTitle !== null && primaryBtnTitle !== void 0 ? primaryBtnTitle : t('common:back_to_search'),
      variant: !secondaryButtonProps ? 'secondary-outline' : 'normal',
      onClick: primaryBtnOnClick,
      fullwidth: true
    }), !!secondaryButtonProps && /*#__PURE__*/_jsx(Button, {
      title: secondaryButtonProps.title,
      variant: "secondary-outline",
      onClick: secondaryButtonProps.onClick,
      fullwidth: true
    })]
  });
});
export default JobNotFoundPage;

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-not-found-page__Wrapper",
  componentId: "sc-1y6kjy9-0"
})(["", " ", ""], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "display": "flex",
  "width": "100%",
  "maxWidth": "24rem",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "1rem",
  "textAlign": "center"
}, function (_ref2) {
  var twStyle = _ref2.twStyle;
  return twStyle;
});